import React from "react";
import * as styles from "./style.mod.scss";
import Link from "components/link";
import {
  box, imgBox, imgBoxSelected, selectedVariant
} from "../variant-list/style.mod.scss";
import getImagePath from "helpers/get-image-path";

const SwitcherWithVariants = ({ content, product }) => {

  let productHanlde;
  if (product?.currentVariant?.handle?.current != null) {
    productHanlde = `/products/${product?.handle}/${product?.currentVariant?.handle?.current}`;
  }
  else {
    productHanlde = product?.handle;
  }

  if (content?.products == null) return<></>;
  return (
    <>
      <div className={styles.advancedProductGroup} style={{ margin: "1re 0 0 0" }}>
        <ul>
          {content?.products?.map((link, i) => {
            if (link?._type == "productLink") {
              return (
                <Link partiallyActive={true} className={styles.linkBox} activeClassName={styles.selected} to={link?.url} key={i} state={{ preserveScroll: true }}>
                  {link?.title}
                  <span>{link?.secondaryName}</span>
                </Link>
              );
            }
            else {
              return (
                <Link partiallyActive={true} className={styles.linkBox}  activeClassName={styles.selected} to={`${link?.variants[0]?.url}`} key={i} state={{ preserveScroll: true }}>
                  {link?.title}
                  <span>{link?.secondaryName}</span>
                </Link>
              );
            }
          }
          )}
        </ul>
      </div>
      {content?.products?.map((link, i) => {
        if (link?._type == "productWithVariants") {
          return (
            <>
              {(productHanlde == link.variants[0]?.url || productHanlde == link.variants[1]?.url) &&
                <ul key={i} className={`${box} ${styles.variantImages}`}>
                  {link?.variants?.map((data, i) => {
                    return (
                      <li className={`${imgBox} ${productHanlde == (data?.url) && imgBoxSelected}`} key={i}>
                        <Link
                          to={data?.url}
                          state={{ preserveScroll: true }}>
                          <img className={selectedVariant} src={getImagePath(data?.image) || data?.image} alt={data?.image?.alt} />
                        </Link>
                      </li>
                    );
                  })}
                </ ul>
              }
            </>
          );
        }
      })
      }
    </>
  );
};

export default SwitcherWithVariants;